export default function ModalShell({ open, onClose, children, width = 520 }) {
  if (!open) return null;

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: width }}>
          <div className="modal-content border-0" style={{ borderRadius: 18, overflow: "hidden" }}>
            {children}
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show" onClick={onClose} style={{ cursor: "pointer" }} />
    </>
  );
}